import { getRecordingApi } from '@fullstory/browser-api';

type SchemaValue =
  | 'real'
  | 'int'
  | 'str'
  | 'bool'
  | 'date'
  | 'reals'
  | 'ints'
  | 'strs'
  | 'bools'
  | 'dates';

export type Schema = { [name: string]: SchemaValue | Schema };

export const FsEvent = {
  /**
   * @deprecated use recordCustomEventV2 instead
   */
  recordCustomEvent: (event: string, properties: { [name: string]: any }) => {
    const api = getRecordingApi(window);
    api?.event(event, properties);
  },

  /**
   * Helper to record a custom event. This uses the FullStory Browser API v2 under the hood. Type suffixes should
   * not be used with this method. In rare cases you may want to include a schema to override what the server infers.
   *
   * See https://developer.fullstory.com/browser/custom-properties/ for more information
   *
   * @param event the name of the event
   * @param properties any custom properties for the event. NOTE: type suffixes
   *                   should not be included (they will be inferred on the server)
   * @param schema optional any schema values that might differ from what would be inferred on the server
   *               Example: "int" (server infers all numbers as "real")
   */
  recordCustomEventV2: (event: string, properties: { [name: string]: any }, schema?: Schema) => {
    const api = getRecordingApi(window);
    api?.('trackEvent', {
      name: event,
      properties,
      ...(schema ? { schema: { properties: schema } } : {}),
    });
  },

  canRecordCustomEvent: (): boolean => {
    const api = getRecordingApi(window);
    return typeof api?.('getSession') === 'string';
  },
};
